<!--Klassifiierung-->
<div class="dx-fieldset">
  <div >{{ 'Klassifizierungssysteme' | translate }}</div>
      <dx-tag-box style="width: 60%" [(value)]="selectedClassificationSystemIds"
                  [dataSource]="classificationSystems"
                  displayExpr="name"
                  valueExpr="id"
                  [showDropDownButton]="true"
                  [acceptCustomValue]="false"
                  placeholder="{{ 'Bitte auswählen' | translate }}"
                  class="hint"
                  [readOnly]="readOnlyUser('classifiction')"
                  (onValueChanged)="onTagBoxChange($event)">
      </dx-tag-box>
</div>
